import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();
const MOBILE_REDIRECT = 'com.theigniteapp.app://';
const WEB_REDIRECT    = process.env.REACT_APP_REDIRECT_SIGN_IN || 'https://www.theigniteapp.com';

// On native iOS, open the Cognito OAuth URL in SFSafariViewController so Apple
// doesn't reject the app for launching system Safari during sign-in (Guideline 4).
// Android and web use the default window.location.assign() behaviour.
const urlOpener = async (url) => {
  if (Capacitor.isNativePlatform()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url, toolbarColor: '#1B4F8A' });
  } else {
    window.location.assign(url);
  }
};

const awsConfig = {
  Auth: {
    region:                process.env.REACT_APP_AWS_REGION      || 'us-east-1',
    userPoolId:            process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId:   process.env.REACT_APP_COGNITO_CLIENT_ID,
    authenticationFlowType: 'USER_SRP_AUTH',

    // ── OAuth / Hosted UI (required for Google & Apple sign-in) ──────────────
    // Set REACT_APP_COGNITO_DOMAIN to your Cognito domain prefix, e.g.:
    //   ignite-prod   →  https://ignite-prod.auth.us-east-1.amazoncognito.com
    // Guard: if REACT_APP_COGNITO_DOMAIN is not set, omit the oauth block entirely
    // so Amplify doesn't construct an invalid "undefined.auth..." domain.
    ...(process.env.REACT_APP_COGNITO_DOMAIN
      ? {
          oauth: {
            domain:         `${process.env.REACT_APP_COGNITO_DOMAIN}.auth.${process.env.REACT_APP_AWS_REGION || 'us-east-1'}.amazoncognito.com`,
            scope:          ['email', 'openid', 'profile'],
            redirectSignIn:  isNative ? MOBILE_REDIRECT : WEB_REDIRECT,
            redirectSignOut: isNative ? MOBILE_REDIRECT : WEB_REDIRECT,
            responseType: 'code',
            urlOpener,
          },
        }
      : {}),
  },
};

export default awsConfig;
